

<div class="ttmodal" style="min-width: 50vw;">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Document Library</span>
      <span>
        <i  style="vertical-align: bottom; margin-left: 2%;border: solid #1F91BC thick; " 
        class="material-icons">picture_as_pdf</i> Global
      </span>
      <span>
        <i style="vertical-align: bottom; margin-left: 2%;border: solid #BC1FBC thick; " 
        class="material-icons" >picture_as_pdf</i> Asset
      </span>
     
      

      <button mat-raised-button color="warn">
        <span  (click)="LoadGlobalDocs()">Display Global Doc List</span>
      </button>
      <button mat-raised-button color="warn">
        <span  (click)="LoadAllDocumentLibraryForImplement()">Display Asset Doc List</span>
      </button>
      <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
  </div>
  <!-- <div class="ttmodal__header">
    <span class="ttmodal__title"></span>
    
</div> -->
  <div class="ttmodal__body">    
    <div class="ttmodal__header">
      <span class="ttmodal__title">{{Title}}</span>
      </div>
 
      <div  style="overflow-y: auto; height:350px; ">

        <div style="margin-left: 20%; position: absolute;" *ngIf="isLoading">
          <mat-spinner></mat-spinner>
        </div>
      <table class="table table--striped table--full-width">
          <thead>             
              <th style="padding: 1px!important;">Incl.</th>
              <th style="padding: 1px!important;">Description</th>
              <th *ngIf="isGlobal==false" style="padding: 1px!important;"></th>

              <th style="padding: 1px!important;">#</th>
              <th style="padding: 1px!important;">Doc.</th>
              <th *ngIf="isGlobal==false" style="padding: 1px!important;">Edit</th>
              <th *ngIf="isGlobal==false" style="padding: 1px!important;">Last Activity</th>
              <th *ngIf="isGlobal==false" style="padding: 1px!important;">Audit</th>
              <th></th>
            
          </thead>
          <tbody>
            <tr *ngFor="let doc of DocumenentList">
              <td>
                <mat-checkbox  id="chkComponent-{{doc.DocId}}" [checked]="doc.isSelect" [value]="doc.DocId" color="primary"
                (change)="DocumentCkhChange(doc.DocId,doc)"></mat-checkbox>
              </td>
              <td style="padding: 1px!important;">{{doc.DocType}}</td>
              <td  *ngIf="isGlobal==false"style="padding: 1px!important;" >
                <i style="cursor: pointer;vertical-align: bottom; margin-left: 2%;" class="material-icons"
                 (click)="AddNewAttachment(doc.DocId)" title="Add New Doc">add</i>
              </td>
              <td style="padding: 1px!important;">{{doc.NoAttchments}}</td>
              <td style="padding: 1px!important;">
                <ng-container *ngFor="let attachment of doc.DocumentAttachments">
               
                  <ng-container *ngIf="isGlobal==false">
                    
                      <i *ngIf="attachment.IsGloble" style="cursor: pointer;vertical-align: bottom; margin-left: 2%;border: solid #1F91BC thick; " 
                      class="material-icons" (click)="onClickDownloadAttachment(attachment,doc)"  title={{attachment.FileName}}> description</i>
                  
                     
                    
                      <i *ngIf="!attachment.IsGloble" style="cursor: pointer;vertical-align: bottom; margin-left: 2%;border: solid #BC1FBC thick; " 
                      class="material-icons" (click)="onClickDownloadAttachment(attachment,doc)" title={{attachment.FileName}}> description</i>
                      <!-- <span style="cursor: pointer;font-size: 13px; max-width: 10em; overflow-wrap: break-word;">{{attachment.FileName}}</span> -->
                    
                  </ng-container>

                  <ng-container *ngIf="isGlobal==true">
                    <div *ngIf="attachment.IsGloble">
                      <i  style="cursor: pointer;vertical-align: bottom; margin-left: 2%;border: solid #1F91BC thick; " 
                      class="material-icons" (click)="onClickDownloadAttachment(attachment,doc)"  title={{attachment.FileName}}> description</i>
                      <span style="cursor: pointer;font-size: 13px; max-width: 10em; overflow-wrap: break-word;">{{attachment.FileName}}</span>
                    </div>
                     
                    <div *ngIf="!attachment.IsGloble">
                      <i  style="cursor: pointer;vertical-align: bottom; margin-left: 2%;border: solid #BC1FBC thick; " 
                      class="material-icons" (click)="onClickDownloadAttachment(attachment,doc)" title={{attachment.FileName}}> description</i>
                    </div>
                  </ng-container>

                  

                   
                    <!-- <i *ngIf="!attachment.IsGloble" style="cursor: pointer;vertical-align: bottom; margin-left: 2%;border: solid #BC1FBC thick; " 
                    class="material-icons" (click)="onClickDownloadAttachment(attachment,doc)"> <span style="cursor: pointer;font-size: 13px; max-width: 10em; overflow-wrap: break-word;">{{attachment.FileName}}</span></i>
   -->
                    
                  
                  

                  <i *ngIf="!isGlobal && doc.ShowReplace==true" style="cursor: pointer;vertical-align: bottom; margin-left: 2%; " 
                  class="material-icons" (click)="ReplaceAttachment(doc.DocId,attachment)" title="Replace with New Doc">upgrade</i>
                </ng-container>
               
              </td>
              <td  *ngIf="isGlobal==false"style="padding: 1px!important;" >
                <i style="cursor: pointer;vertical-align: bottom; margin-left: 2%;" class="material-icons"
                 (click)="ShowUpgrade(doc)">edit</i>
              </td>
              <td *ngIf="isGlobal==false" style="padding: 1px!important;">{{doc.ModifiedDate}}</td>
              <td  *ngIf="isGlobal==false " style="padding: 1px!important;" >
                <i  *ngIf="doc.ModifiedDate!=''" style="cursor: pointer;vertical-align: bottom; margin-left: 2%;" class="material-icons" (click)="openDocumentAdjustmentAuditTrailDialog(doc.DocId)">chat</i>
              </td>
            </tr>
          </tbody>
      </table>
      </div>
  </div>

</div>